import React from "react";
import styles from "./GalleryAmigurumis.module.css";
import poke1 from "../data/assets/Games/pokemon/pikachu/pikachu-1.png";
import poke2 from "../data/assets/Games/pokemon/popplio/popplio-1.png";
import poke3 from "../data/assets/Games/pokemon/zorua/zorua-1.png";
import poke4 from "../data/assets/Games/pokemon/zorua/zorua-4.png";
import poke5 from "../data/assets/Games/pokemon/charmander/Group 103.png";
import poke6 from "../data/assets/Games/pokemon/charmander/Group 104.png";
import poke7 from "../data/assets/Games/pokemon/charmander/Group 107.png";
import poke8 from "../data/assets/Games/pokemon/charmander/Group 108.png";

import sv1 from "../data/assets/Games/stardewValley/estrella.png";
import sv2 from "../data/assets/Games/stardewValley/junimo.png";

import anime1 from "../data/assets/Anime/Avatar/Aang/aang-1.png";
import anime2 from "../data/assets/Anime/Avatar/Zuko/Zuko-1.png";
import anime3 from "../data/assets/Anime/Ghibli/SinCara-1.png";
import anime4 from "../data/assets/Anime/Berserk/Group 101.png";
import anime5 from "../data/assets/Anime/Berserk/Group 102.png";
import anime6 from "../data/assets/Anime/Berserk/Group 109.png";

import llaveros1 from "../data/assets/Anime/OnePiece/Luffy-3.png";
import llaveros2 from "../data/assets/Anime/OnePiece/Chopper-1.png";

function GalleryAnime() {
  const data = [
    anime4,
    poke1,
    anime1,
    llaveros1,
    poke5,
    poke2,
    anime2,
    sv1,
    poke6,
    anime5,
    llaveros2,
    poke3,
    poke4,
    sv2,
    anime6,
    poke7,
    anime3,
    poke8,
  ];
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Personajes de anime y juegos</h2>
      <div className={styles.gallery}>
        {data.map((item, i) => (
          <figure className={styles.item} key={i}>
            <img src={item} alt="foto" className={styles.image}></img>
          </figure>
        ))}{" "}
      </div>
    </div>
  );
}

export { GalleryAnime };
